import { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "../../styles/FloatingLabelInput.css";

const FloatingLabelPhoneInput = ({
  label,
  value,
  onChange,
  required = false,
  defaultCountry = "IN",
  error = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const shouldFloat = isFocused || value;

  return (
    <div className={`input-wrapper phone-wrapper ${error ? "error" : ""}`}>
      <PhoneInput
        international
        defaultCountry={defaultCountry}
        countryCallingCodeEditable={false}
        value={value}
        onChange={(val) => onChange(val || "")}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />

      <label className={`floating-label ${shouldFloat ? "float" : ""}`}>
        {label} {required && "*"}
      </label>
    </div>
  );
};

export default FloatingLabelPhoneInput;
